import { useEffect, useMemo, useState } from "react";
import { FaEdit, FaEye, FaTrash } from "react-icons/fa";
import { formatContentDate } from "../utils/contentUtils";

const BOOK_PLACEHOLDER_IMAGE = `data:image/svg+xml;utf8,${encodeURIComponent(`
<svg xmlns="http://www.w3.org/2000/svg" width="220" height="280" viewBox="0 0 220 280">
  <defs>
    <linearGradient id="cover" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0%" stop-color="#edf4f1" />
      <stop offset="100%" stop-color="#dbe9e4" />
    </linearGradient>
  </defs>
  <rect width="220" height="280" fill="url(#cover)" />
  <rect x="30" y="30" width="160" height="220" rx="12" fill="#ffffff" stroke="#cddbd5" />
  <rect x="44" y="46" width="16" height="188" rx="6" fill="#1d6257" />
  <rect x="70" y="84" width="108" height="12" rx="6" fill="#d7e7e1" />
  <rect x="70" y="106" width="98" height="10" rx="5" fill="#e6f0ec" />
  <rect x="70" y="125" width="84" height="10" rx="5" fill="#e6f0ec" />
  <text x="124" y="182" fill="#2f5850" font-size="28" font-family="Arial, sans-serif" font-weight="700" text-anchor="middle">BOOK</text>
</svg>
`)}`;

const ContentCard = ({ item, onPreview, onEdit, onDelete }) => {
    const categories = item.categories?.length ? item.categories.join(", ") : "Uncategorized";
    const hasImageUrl = useMemo(
        () => Boolean(item.imageUrl && item.imageUrl !== "no-image.jpg"),
        [item.imageUrl]
    );
    const [imageSrc, setImageSrc] = useState(hasImageUrl ? item.imageUrl : BOOK_PLACEHOLDER_IMAGE);

    useEffect(() => {
        setImageSrc(hasImageUrl ? item.imageUrl : BOOK_PLACEHOLDER_IMAGE);
    }, [item.imageUrl, hasImageUrl]);

    return (
        <article className="content-card">
            <div className="content-cover" aria-hidden="true">
                <img
                    src={imageSrc}
                    alt=""
                    loading="lazy"
                    onError={() => {
                        if (imageSrc !== BOOK_PLACEHOLDER_IMAGE) {
                            setImageSrc(BOOK_PLACEHOLDER_IMAGE);
                        }
                    }}
                />
            </div>
            <div className="content-card-body">
                <h2>{item.title || "Untitled content"}</h2>
                <p className="content-meta">By {item.author || "ReadWell"}</p>
                <dl className="content-facts">
                    <div>
                        <dt>Level</dt>
                        <dd>{item.level || "A"}</dd>
                    </div>
                    <div>
                        <dt>Difficulty</dt>
                        <dd>{item.difficulty || "MEDIUM"}</dd>
                    </div>
                    <div>
                        <dt>Paragraphs</dt>
                        <dd>{item.paragraphCount}</dd>
                    </div>
                    <div>
                        <dt>Created</dt>
                        <dd>{formatContentDate(item.createdAt)}</dd>
                    </div>
                </dl>
                <p className="content-categories">{categories}</p>
            </div>
            <div className="content-card-actions">
                <button type="button" onClick={() => onPreview(item)} className="content-action-btn">
                    <FaEye aria-hidden="true" />
                    <span>Preview</span>
                </button>
                <button type="button" onClick={() => onEdit(item)} className="content-action-btn">
                    <FaEdit aria-hidden="true" />
                    <span>Edit</span>
                </button>
                <button
                    type="button"
                    onClick={() => onDelete(item)}
                    className="content-action-btn danger"
                >
                    <FaTrash aria-hidden="true" />
                    <span>Delete</span>
                </button>
            </div>
        </article>
    );
};

export default ContentCard;
